import React from 'react';
import { CaptureOverlay } from '../capture/shared';
import './ErrorOverlay.css';

export interface ErrorOverlayProps {
  taskName?: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  /** Use dark viewfinder background (photo/video errors) */
  darkBg?: boolean;
  /** Warning-style icon circle instead of error-red */
  warnIcon?: boolean;
  onRetry?: () => void;
  onClose: () => void;
}

export const ErrorOverlay: React.FC<ErrorOverlayProps> = ({
  taskName,
  icon,
  title,
  description,
  darkBg = false,
  warnIcon = false,
  onRetry,
  onClose,
}) => {
  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className={darkBg ? 'eo-body-dark' : 'eo-body'}>
        <div className={`eo-icon${warnIcon ? ' eo-icon-warn' : ''}`}>
          {icon}
        </div>
        <div className="eo-title">{title}</div>
        <div className="eo-desc">{description}</div>

        {onRetry ? (
          <div className="eo-btn-row">
            <button className="eo-btn-retry" onClick={onRetry}>Try Again</button>
            <button className="eo-btn-dismiss" onClick={onClose}>Close</button>
          </div>
        ) : (
          <button className="eo-btn-close" onClick={onClose}>Close</button>
        )}
      </div>
    </CaptureOverlay>
  );
};
